export default "__VITE_ASSET__91278fae__"